<template>
	<div class="w-full flex" ref="mainEl">
		<div class="w-fit" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd" ref="btnEl">
			<img alt="" src="images/1x_images/drag-btn.png" srcset="images/2x_images/drag-btn.png 2x" class="p-[0] absolute bottom-[-5px] will-change-[unset]" />
		</div>
	</div>
</template>

<script>
/* eslint-disable */
import gsap from "gsap";

export default {
	props: {
		// images: 0,
		// type: "",
	},
	data() {
		return {
			startX: 0,
			moveX: 0,
			btnMin: 0,
			btnMax: 0,
			checkpoints: [],
			lastTrigger: 0,
		};
	},
	methods: {
		handleTouchStart(e) {
			this.startX = e.touches[0].clientX / ratioToOriginal;
		},
		handleTouchMove(e) {
			e.preventDefault();
			var currentX = e.touches[0].clientX / ratioToOriginal;

			var moveX = currentX - this.startX;
			this.startX = currentX;
			this.moveX += moveX;

			if (this.moveX <= 0) {
				this.moveX = 0;
			} else if (this.moveX >= this.btnMax) {
				this.moveX = this.btnMax;
			}

			this.updateOpacity(this.moveX);
			gsap.set(this.$refs.btnEl, { x: this.moveX });
		},
		handleTouchEnd(e) {},
		updateOpacity(pos) {
			var opacity = pos / this.btnMax;
			this.$emit("trigger", opacity);
			// console.log(opacity);
		},
		reset() {
			this.moveX = 0;
			gsap.set(this.$refs.btnEl, { x: this.moveX });
		},
	},
	mounted() {
		const btnImg = this.$refs.btnEl.querySelector("img");
		btnImg.addEventListener("load", () => {
			const rect = this.$refs.mainEl.getBoundingClientRect();
			const btn = btnImg.getBoundingClientRect();
			this.btnMax = (rect.width - btn.width) / ratioToOriginal;
			this.reset();
		});
	},
};
</script>

<style scoped></style>
